/**
 * User-like object that has isAnonymous and email properties
 * Works with both IUser and Firebase User
 */
type UserLike = {
  isAnonymous?: boolean;
  email?: string | null;
};

/**
 * Check if user is anonymous - handles Firebase bug where isAnonymous
 * can return false for anonymous users
 * @see https://github.com/firebase/flutterfire/issues/3667
 */
export const isUserAnonymous = (user: UserLike | null | undefined): boolean => {
  if (!user) return true;
  return user.isAnonymous === true || !user.email;
};
